import React, { Component } from "react";
import { connect } from "react-redux";
import { analyticsFEA } from "src/AnalyticsFEA";
import ArrowRightIcon from "src/components/icons/ArrowRight";
import Modal from "src/components/Modal/index";
import ReserveVehicle from "src/components/MyGarage/VehicleHeader/ExploreMore/ReserveVehicle";
import { getAccountDisclaimer } from "src/store/selectors/accountDisclaimers";
import { getIsReserveVehicleEnabled, getTestDriveEnabled } from "src/store/selectors/electricSettings";
import { ApplicationStore, VehicleState } from "Types/state";
import { openTestDriveModal } from "src/store/actions/testDrive";
import { hasTestDrive } from "src/store/selectors/testDrive";
import { History } from "history";
import withFrame, { WithFrameProps } from "src/providers/frame/withFrame";

interface Props {
    continueDealAllowed: boolean;
    history: History;
    onClose: any;
    testDriveEnabled: boolean;
    testDriveButtonText: string;
    updateCurrentDeal: (vin: string) => void;
    uuid: string;
    vehicle: VehicleState;
    vin: string;
    continueDealCTAText: string;
    reserveVehicleEnabled: boolean;
    reserveVehicleButtonText: string;
    openTestDrive: typeof openTestDriveModal;
    hasTestDrive: boolean;
}

interface State {
    isReserveVehicleModalOpen: boolean;
}

class ExploreMoreMenu extends Component<Props & WithFrameProps, State> {
    private readonly wrapperRef: any;

    constructor(props: Props & WithFrameProps) {
        super(props);
        this.state = {
            isReserveVehicleModalOpen: false,
        };

        this.wrapperRef = React.createRef();
    }

    public render() {
        const {
            reserveVehicleEnabled,
            testDriveButtonText,
            testDriveEnabled,
            continueDealCTAText,
            reserveVehicleButtonText,
        } = this.props;

        return (
            <div className="Explore__menu" ref={this.wrapperRef}>
                <ul>
                    {this.props.continueDealAllowed && (
                        <li onClick={this.continueDeal} className="Explore__menu--option">
                            <div>{continueDealCTAText}</div>
                            <ArrowRightIcon />
                        </li>
                    )}
                    {reserveVehicleEnabled && (
                        <li className="Explore__menu--option" onClick={this.toggleReserveVehicle(true)}>
                            <div>{reserveVehicleButtonText}</div>
                            <ArrowRightIcon />
                        </li>
                    )}
                    {testDriveEnabled && (
                        <li
                            className="Explore__menu--option"
                            onClick={() => {
                                this.props.openTestDrive(this.props.hasTestDrive, this.props.history);
                                this.props.onClose();
                            }}
                        >
                            <div>{testDriveButtonText}</div>
                            <ArrowRightIcon />
                        </li>
                    )}
                </ul>
                <Modal open={this.state.isReserveVehicleModalOpen} closeModal={this.toggleReserveVehicle(false)}>
                    <ReserveVehicle
                        closeModal={this.toggleReserveVehicle(false)}
                        CTAText={reserveVehicleButtonText}
                        vehicle={this.props.vehicle}
                        vin={this.props.vin}
                    />
                </Modal>
            </div>
        );
    }

    public componentDidMount() {
        this.props.iframe.document.addEventListener("mousedown", this.handleClickOutside);
    }

    public componentWillUnmount() {
        this.props.iframe.document.removeEventListener("mousedown", this.handleClickOutside);
    }

    private handleClickOutside = (event: any) => {
        if (this.wrapperRef && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            if (!this.state.isReserveVehicleModalOpen) {
                this.props.onClose();
            }
        }
    };

    private continueDeal = () => {
        const vehicle = this.props.vehicle;

        analyticsFEA.engine.calculationFinish(this.props.uuid, [vehicle]);
        analyticsFEA.engine.continueDeal(this.props.vin);

        this.props.updateCurrentDeal(this.props.vin);
        this.props.history.push("/continue-deal");
    };

    private toggleReserveVehicle = (isOpen: boolean) => () => {
        if (isOpen) {
            analyticsFEA.engine.calculationFinish(this.props.uuid, [this.props.vehicle]);
        }
        this.setState({ isReserveVehicleModalOpen: isOpen });
    };
}

const mapStateToProps = (state: ApplicationStore) => ({
    continueDealCTAText: getAccountDisclaimer(
        state,
        "garage_continue_deal_cta",
        "MyGarage.TableCompare.VehicleHeader.ExploreMoreMenu.continueDealOnlineOption"
    ),
    reserveVehicleButtonText: getAccountDisclaimer(
        state,
        "garage_reserve_vehicle_cta",
        "MyGarage.TableCompare.VehicleHeader.ExploreMoreMenu.reserveVehicleOption"
    ),
    reserveVehicleEnabled: getIsReserveVehicleEnabled(state),
    testDriveButtonText: getAccountDisclaimer(state, "test_drive_cta"),
    testDriveEnabled: getTestDriveEnabled(state),
    hasTestDrive: hasTestDrive(state),
    uuid: state.deal.uuid as string,
});

export default connect(mapStateToProps, { openTestDrive: openTestDriveModal })(withFrame(ExploreMoreMenu));
